module.exports = __webpack_public_path__ + "kubernetes-cluster.f7c2315862d11f3e75221799bc4ccc15.hashedasset.svg";